<template>
  <div>
    <Editor
      ref="editor"
      :document="chart"
      :objectsCreationAllowed="false"
      :singleIndicator="true"
      @saveDocument="saveDocument"
      @generateDocument="saveAndGenerateDocument"
      v-if="!isLoading"
      :key="componentKey"
      :storeNamespace="storeNamespace"
    >
      <template v-slot:title>
        {{ title }}
      </template>

      <template v-slot:navigation>
        <slot name="navigation"></slot>
      </template>
    </Editor>

    <b-loading :is-full-page="isFullPage" :active.sync="isLoading"></b-loading>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  components: {
    Editor: () =>
      import(
        /* webpackChunkName: "Editor" */ '@/components/shared/document/Editor'
      ),
  },

  mounted() {
    if (this.$route.params.id) {
      this.getChart(this.$route.params.id).then(() => {
        this.pageTitle = 'Чарт: ' + this.chart.name
        this.title = 'Чарт'
        this.isLoading = false
      })
    } else {
      this.clearChart().then(() => {
        this.pageTitle = 'Новый чарт'
        this.title = this.pageTitle
        this.componentKey++
        this.isLoading = false
      })
    }
  },

  metaInfo() {
    return {
      title: this.pageTitle,
    }
  },

  data() {
    return {
      isLoading: true,
      isFullPage: true,
      title: null,
      pageTitle: null,
      componentKey: 0,
      storeNamespace: 'chart',
    }
  },

  computed: {
    ...mapState({
      chart: state => state.chart,
    }),
  },

  methods: {
    ...mapActions('chart', {
      getChart: 'getChart',
      clearChart: 'clearChart',
      patchChart: 'patchChart',
      postChart: 'postChart',
    }),

    ...mapActions('document', {
      postDocument: 'postDocument',
    }),

    async saveAndGenerateDocument(variables) {
      await this.saveDocument()

      this.isLoading = true

      const data = {
        templateId: this.$route.params.id,
        data: {
          variables: variables,
        },
      }

      await this.postDocument(data)
        .then(res => {
          this.$router.push({
            name: 'document.view',
            params: { id: res.data.id },
          })
        })
        .catch(err => {
          this.toast({
            message: `Ошибка ${err}`,
            type: 'is-danger',
          })
        })

      this.isLoading = false
    },

    async saveDocument() {
      this.isLoading = true
      const editor = this.$refs.editor.$refs.textEditor

      const data = {
        name: editor.title,
        data: {
          content: editor.editorData,
          codes: this.chart.data.codes,
          variables: this.chart.data.variables,
        },
      }

      if (this.$route.params.id !== undefined) {
        await this.patchChart({
          id: this.$route.params.id,
          data: data,
        })
          .then(() => {
            this.toast({
              message: 'Сохранено',
              type: 'is-success',
            })
            this.componentKey++
          })
          .catch(err => {
            this.toast({
              message: `Ошибка ${err}`,
              type: 'is-danger',
            })
          })
      } else {
        await this.postChart(data)
          .then(res => {
            this.toast({
              message: 'Сохранено',
              type: 'is-success',
            })
            this.$router.push({
              name: 'chart.view',
              params: { id: res.data.id },
            })
          })
          .catch(err => {
            this.toast({
              message: `Ошибка ${err}`,
              type: 'is-danger',
            })
          })
      }

      this.isLoading = false
    },
  },
}
</script>
